// actions
import { authConstants } from "../constants/auth";

export const authLoginSucces = (user_id, user_name, user_type) => ({
    type: authConstants.LOGIN_SUCCES,
    user_id,
    user_name,
    user_type
});

export const authLogoutSucces = () => ({
    type: authConstants.LOGOUT_SUCCES
});

